import * as React from 'react';
export const SMSvg = React.forwardRef(function SMSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M1.994 0A1.998 1.998 0 0 0 0 1.998V6h16V1.998A1.997 1.997 0 0 0 14.006 0H1.994Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M14 0a2 2 0 0 1 2 2v4h-1V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v4H0V2a2 2 0 0 1 2-2h12Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#217AB7',
        d: 'M0 6v4.002C0 11.106.895 12 1.994 12h12.012A1.998 1.998 0 0 0 16 10.002V6H0Z',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: 8,
        cy: 6,
        r: 2,
        fill: '#F4B32E',
      }),
    ),
  );
});
SMSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var SM = {
  category: 'flag',
  colorable: false,
  name: 'SM',
  svg: SMSvg,
};
